import React from 'react';
import KitchenProcurementContent from './content';
import { KitchenProcurementProvider } from 'contexts/kitchen/procurement.context';

const KitchenProcurementLayout = () => {
  return (
    <KitchenProcurementProvider>
      <KitchenProcurementContent />
    </KitchenProcurementProvider>
  );
};

export default KitchenProcurementLayout;
